module.exports = __webpack_public_path__ + "static/img/DYCode.43f2701.png";


//////////////////
// WEBPACK FOOTER
// ./static/footer/DYCode.png
// module id = UIzh
// module chunks = 3